import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowPointerLeft = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M877.714 438.853h-555.155l241.371-240.64c13.773-13.773 21.511-32.453 21.511-51.931s-7.738-38.158-21.511-51.931c-13.774-13.773-32.453-21.511-51.931-21.511s-38.159 7.738-51.931 21.511l-365.714 365.714c-6.659 6.957-11.879 15.159-15.36 24.137-7.316 17.807-7.316 37.781 0 55.589 3.481 8.978 8.701 17.181 15.36 24.137l365.714 365.711c6.799 6.861 14.889 12.303 23.802 16.011 8.913 3.716 18.474 5.625 28.129 5.625s19.216-1.909 28.129-5.625c8.913-3.708 17.003-9.15 23.803-16.011 6.856-6.795 12.297-14.885 16.010-23.801 3.713-8.909 5.625-18.469 5.625-28.131 0-9.655-1.912-19.215-5.625-28.123-3.713-8.916-9.155-17.006-16.010-23.808l-241.371-240.637h555.155c19.397 0 38.005-7.706 51.719-21.423s21.424-32.321 21.424-51.72c0-19.399-7.709-38.003-21.424-51.72s-32.322-21.423-51.719-21.423z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgArrowPointerLeft);
export default ForwardRef;
